<template>
    <div class="container">
        <header>
            <span class="btn" @click="router.back()"><van-icon name="arrow-left" size="20" /></span>
        </header>
        <header @click="showSide=true" class="t2">
            <van-icon :name="require('@/assets/imgs/icon34.png')" size="20" style="margin-right: 10rem;" />
            <span>帮助中心</span>
        </header>
        <div v-html="content" class="content">

        </div>
    </div>

    <div class="wrapper" v-show="showSide">
        <aside>
            <h3><span>帮助中心</span> <span class="btn" @click="router.back()"><van-icon name="cross" size="20" /></span>
            </h3>
            <ul>
                <li v-for="item in list" :key="item.id">
                    <h5 @click="item.show = !item.show">
                        <span>{{ item.typeName }}</span>
                        <van-icon name="arrow" color="#383838" v-if="!item.show" />
                        <van-icon name="arrow-down" color="#383838" v-else />
                    </h5>
                    <ul v-show="item.show">
                        <li v-for="subItem in item.helpData" :key="subItem.id"
                            :class="['sub_item', subItem.id == currentId ? 'active' : '']"
                            @click="changeActive(subItem.id)">{{ subItem.name }}</li>
                    </ul>
                </li>
            </ul>
        </aside>
    </div>


</template>
<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { http } from '@/request/http.js'

const showSide = ref(false)
const list = ref([])
const currentId = ref('')
const content = ref('')
const router = useRouter(), route = useRoute()
onMounted(() => {
    http.get('/app-api/member/help-center/typeList').then(res => {
        res.map(item => item.show = true)
        list.value = res
        if(route.query.id){
            changeActive(route.query.id)
        }else{
            changeActive(list.value[0].helpData[0].id)
        }
    })
})
const changeActive = (id) => {
    currentId.value = id
    var target = null
    list.value.map(item => {
        const res = item.helpData.find(subItem => subItem.id == id)
        if (res) target = res
    })
    if(target) content.value = target.content
    window.scrollTo(0, 0)
    showSide.value = false
}
</script>
<style scoped lang="scss">
.container {
    padding-bottom: 50rem;
    min-height: 100vh;

    header {
        display: flex;
        align-items: center;
        height: 40rem;
        padding: 0 20rem;
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 999;
    }
    .t2{
        position: sticky;
        top: 40rem;
    }

    .content{
        padding: 20rem;
    }
}

.wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 999;

    h3 {
        align-items: center;
        height: 40rem;
        display: flex;
        justify-content: space-between;
        font-size: 18rem;
    }
}

aside {
    width: 310rem;
    height: 100vh;
    overflow-y: scroll;
    background-color: #fff;
    padding: 20rem;

    h5 {
        height: 40rem;
        line-height: 40rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #383838;
    }

    li {
        .sub_item {
            width: 100%;
            height: 40rem;
            line-height: 40rem;
            padding: 0 20rem;
            color: #718096;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .active {
        background-color: #F8F8F8;
        color: #000 !important;
    }
}
</style>
